import * as _ from 'jsonous'

import { decodeAndGet } from '../../utils'
import { orderLazyDecoder } from '../decoders'
import type { Order } from '../types'
import { api } from './api'

const ordersDecoder = _.field('orders', _.array(orderLazyDecoder))

export const ordersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getActiveOrders: build.query<Order[], void>({
      query: () => ({
        url: '/arm/corner/orders/in_process',
        method: 'POST',
        body: {},
      }),
      transformResponse: (response: unknown) => {
        const [data, error] = decodeAndGet(ordersDecoder, response)
        if (error) throw new Error(error)
        return data!
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map((o) => ({ type: 'ActiveOrders' as const, id: o.id })),
              'ActiveOrders',
            ]
          : ['ActiveOrders'],
    }),
    getReadyOrders: build.query<Order[], void>({
      query: () => ({
        url: '/arm/corner/orders/ready',
        method: 'POST',
        body: {},
      }),
      transformResponse: (response: unknown) => {
        const [data, error] = decodeAndGet(ordersDecoder, response)
        if (error) throw new Error(error)
        return data!
      },
      providesTags: (result) =>
        result
          ? [
              ...result.map((o) => ({ type: 'ReadyOrders' as const, id: o.id })),
              'ReadyOrders',
            ]
          : ['ReadyOrders'],
    }),
    getTodayOrders: build.query<Order[], void>({
      query: () => ({
        url: '/arm/corner/orders/history',
        method: 'POST',
        body: {},
      }),
      transformResponse: (response: unknown) => {
        const [data, error] = decodeAndGet(ordersDecoder, response)
        if (error) throw new Error(error)
        return data!
      },
      providesTags: ['TodayOrders'],
    }),
  }),
})
